import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CustomFormsModule} from 'ng2-validation';
import {VerifyComponent} from './verify.component';

@NgModule({
  imports: [CommonModule, CustomFormsModule, FormsModule],
  declarations: [VerifyComponent],
  exports: [VerifyComponent],
})
export class VerifyModule {}



// WEBPACK FOOTER //
// ./src/app/auth/verify/verify.module.ts